import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_2 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_3 = {
  class: "p-6 space-y-4"
};
const _hoisted_4 = {
  class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl"
};
import { reactive, computed, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'CategoryFormModal',
  props: {
    category: {
      type: Object,
      default: null
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close', 'save'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      code: '',
      name: '',
      parentId: null,
      icon: '',
      sort: 0,
      description: ''
    });

    // 可选的父分类（排除自己及其子分类）
    const availableParents = computed(() => {
      if (!props.category) return props.categories;
      const excludeIds = new Set();
      function collectIds(cat) {
        excludeIds.add(cat.id);
        if (cat.children) {
          cat.children.forEach(collectIds);
        }
      }
      collectIds(props.category);
      return props.categories.filter(cat => !excludeIds.has(cat.id));
    });
    onMounted(() => {
      if (props.category) {
        form.code = props.category.code || '';
        form.name = props.category.name || '';
        form.parentId = props.category.parentId || null;
        form.icon = props.category.icon || '';
        form.sort = props.category.sort || 0;
        form.description = props.category.description || '';
      }
    });
    function handleSave() {
      if (!form.code.trim()) {
        ElMessage.warning('请输入分类编码');
        return;
      }
      if (!form.name.trim()) {
        ElMessage.warning('请输入分类名称');
        return;
      }
      emit('save', {
        code: form.code,
        name: form.name,
        parentId: form.parentId || null,
        icon: form.icon || null,
        sort: form.sort || 0,
        description: form.description || null
      });
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(AppModal, {
        visible: true,
        size: "md",
        "panel-class": "mx-4",
        onClose: _cache[8] || (_cache[8] = $event => _ctx.$emit('close'))
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("h3", _hoisted_2, _toDisplayString(__props.category ? '编辑分类' : '新增分类'), 1), _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('close')),
          class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer"
        }, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "w-5 h-5",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_cache[10] || (_cache[10] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 分类编码 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.code = $event),
          type: "text",
          class: "form-input w-full",
          placeholder: "请输入分类编码"
        }, null, 512), [[_vModelText, form.code]])]), _createElementVNode("div", null, [_cache[11] || (_cache[11] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, [_createTextVNode(" 分类名称 "), _createElementVNode("span", {
          class: "text-red-500"
        }, "*")], -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.name = $event),
          type: "text",
          class: "form-input w-full",
          placeholder: "请输入分类名称"
        }, null, 512), [[_vModelText, form.name]])]), _createElementVNode("div", null, [_cache[12] || (_cache[12] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "父分类", -1)), _createVNode(_component_el_select, {
          modelValue: form.parentId,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.parentId = $event),
          class: "form-select w-full"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            label: "无（顶级分类）",
            value: null
          }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableParents.value, cat => {
            return _openBlock(), _createBlock(_component_el_option, {
              key: cat.id,
              label: cat.name,
              value: cat.id
            }, null, 8, ["label", "value"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[13] || (_cache[13] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "分类图标", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.icon = $event),
          type: "text",
          class: "form-input w-full",
          placeholder: "请输入图标路径或SVG代码"
        }, null, 512), [[_vModelText, form.icon]])]), _createElementVNode("div", null, [_cache[14] || (_cache[14] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "排序", -1)), _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.sort = $event),
          type: "number",
          class: "form-input w-full",
          placeholder: "数字越小越靠前"
        }, null, 512), [[_vModelText, form.sort, void 0, {
          number: true
        }]])]), _createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", {
          class: "block text-sm font-medium text-slate-700 mb-1"
        }, "描述", -1)), _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.description = $event),
          rows: "3",
          class: "form-textarea",
          placeholder: "请输入分类描述"
        }, null, 512), [[_vModelText, form.description]])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = $event => _ctx.$emit('close')),
          class: "btn-secondary"
        }, " 取消 "), _createElementVNode("button", {
          onClick: handleSave,
          class: "btn-primary"
        }, " 确定 ")])]),
        _: 1
      });
    };
  }
};